import items from '../pt/home/items';
import others from '../pt/home/others';
import wellcome from '../pt/home/wellcome';
import myAccount from '../pt/myAccount';
import roleNames from '../pt/utils/roleNames';
import reasonNames from '../pt/utils/reasonNames';
import objectItems from './menu/objListItems';
import render from './menu/render';
import headRowsEquip from './containers/admin/tables/paramEquipmentModels/headRowsEquip';
import tableTitleEquip from './containers/admin/tables/paramEquipmentModels/tableTitleEquip';
import fetchEquip from './containers/admin/tables/paramEquipmentModels/fetchEquip';
import btn from './containers/admin/tables/paramEquipPlaces/buttonEquip';
import chip from './containers/admin/tables/paramEquipPlaces/chip';
import Equipmament from './containers/admin/tables/paramEquipPlaces/equipmamentChangeStatusInput';
import equipmentsByPlace from './containers/admin/tables/paramEquipPlaces/equipmentsByPlace';
import FileDownloadButton from './containers/admin/tables/paramEquipPlaces/fileDownloadButton';
import TableTitle from './containers/admin/tables/paramEquipPlaces/tableTitle-EquipStatus';
import headRowsFreq from './containers/admin/tables/paramFrequency/headRowsFrequency';
import setLabelFrequency from './containers/admin/tables/paramFrequency/setLabelFrequency';
import tableTitleFrequency from './containers/admin/tables/paramFrequency/tableTitle';
import headRowsGroup from './containers/admin/tables/paramGroups/headRows';
import tableCellGroup from './containers/admin/tables/paramGroups/tableCell';
import tableTitleGroup from './containers/admin/tables/paramGroups/tableTitle';
import tableTitleMap from './containers/admin/tables/paramMaps/tableTitle';
import tableTitlePlaces from './containers/admin/tables/paramPlaces/tableTitle';
import headRowsService from './containers/admin/tables/paramServicos/headRows';
import tableCellService from './containers/admin/tables/paramServicos/tableCell';
import tableTitleService from './containers/admin/tables/paramServicos/tableTilte';
import headRowsVerification from './containers/admin/tables/paramStatusVerificationItems/headRows';
import editSwitch from './containers/admin/tables/paramStatusVerificationItems/switch';
import tableCellVerification from './containers/admin/tables/paramStatusVerificationItems/tableCell';
import TableTitleVerification from './containers/admin/tables/paramStatusVerificationItems/tableTitle';
import headRowsTypeService from './containers/admin/tables/paramTiposServicos/headRows';
import tableCellServiceType from './containers/admin/tables/paramTiposServicos/tableCell';
import tableTitleServiceType from './containers/admin/tables/paramTiposServicos/tableTitle';
import buttonFilterUser from './containers/admin/tables/paramUsers/button';
import clearFilterButton from './containers/admin/tables/paramUsers/clearFilterButton';
import getHoursFromNow from './containers/admin/tables/paramUsers/getHoursFromNow';
import headRowsUsers from './containers/admin/tables/paramUsers/headRows';
import headRowsInvitationsUsers from './containers/admin/tables/paramUsers/headRowsInvitations';
import linkInvitationUserCopiedToClipboard from './containers/admin/tables/paramUsers/linkInvitationCopied';
import tableCellUser from './containers/admin/tables/paramUsers/tableCell';
import tableTitleUser from './containers/admin/tables/paramUsers/tableTitle';
import tabsUser from './containers/admin/tables/paramUsers/tabs';
import headRowsCompany from './containers/admin/tables/tableCompanies/headRows';
import tableCellCompany from './containers/admin/tables/tableCompanies/tableCell';
import tableTitleCompany from './containers/admin/tables/tableCompanies/tableTitle';
import btnFilterManagementEquip from './containers/admin/tables/tableManagementEquips/button';
import clearFilterButtonManagementEquip from './containers/admin/tables/tableManagementEquips/clearFilterButton';
import changeStatusInputManagementEquip from './containers/admin/tables/tableManagementEquips/equipmamentChangeStatusInput';
import headRowsManagementEquip from './containers/admin/tables/tableManagementEquips/headRows';
import tableTitleManagementEquip from './containers/admin/tables/tableManagementEquips/tableTitle';
import btnManagementService from './containers/admin/tables/tableManagementServices/button'
import btnClearFilterManagementService from './containers/admin/tables/tableManagementServices/clearFilterButton';
import headRowsManagementService from './containers/admin/tables/tableManagementServices/headRows';
import tableCellManagementService from './containers/admin/tables/tableManagementServices/tableCell';
import tableTitleManagementService from './containers/admin/tables/tableManagementServices/tableTitle';
import fetchAreas from './containers/admin/tables/tableAreas/fetch';
import headRowsAreas from './containers/admin/tables/tableAreas/headRows';
import tableCellAreas from './containers/admin/tables/tableAreas/tableCell';
import tableTitleAreas from './containers/admin/tables/tableAreas/tableTitle';
import autocompleteFormEquip from './containers/admin/forms/formEquipments/formEquipments/autocomplete';
import avatarFormEquip from './containers/admin/forms/formEquipments/formEquipments/avatar';
import divFormTitle from './containers/admin/forms/formEquipments/formEquipments/divFormTitle';
import equipmentChangeStatusInput from './containers/admin/forms/formEquipments/formEquipments/equipmamentChangeStatusInput';
import handleDeleteEquipment from './containers/admin/forms/formEquipments/formEquipments/handleDeleteEquipment';
import modalEditPhotoFormEquip from './containers/admin/forms/formEquipments/formEquipments/modalEditPhoto';
import photoBarUploadingFormEquip from './containers/admin/forms/formEquipments/formEquipments/photoBarUploading';
import textFieldFormEquip from './containers/admin/forms/formEquipments/formEquipments/textField';
import updateEquipments from './containers/admin/forms/formEquipments/formEquipments/updateEquipments';
import formEquipmentActions from './containers/admin/forms/formEquipments/formEquipmentsActions/tabs';
import formEquipmentsLogs from './containers/admin/forms/formEquipments/formEquipmentsLogs';
import divFromEquipService from './containers/admin/forms/formEquipments/formEquipmentsServices/div';
import typographyformEquipServ from './containers/admin/forms/formEquipments/formEquipmentsServices/typography';
import divFormEquipServType from './containers/admin/forms/formEquipments/formEquipmentsServiceTypes/div';
import keyboardDatePickerFormEquipServType from './containers/admin/forms/formEquipments/formEquipmentsServiceTypes/keyboardDatePicker';
import avatarFormCompany from './containers/admin/forms/formCompany/avatar';
import handleCloseFormCompany from './containers/admin/forms/formCompany/handleClose';
import handleDeleteCompanyFormCompany from './containers/admin/forms/formCompany/handleDeleteCompany';
import handleDeleteCompanyFailformCampany from './containers/admin/forms/formCompany/handleDeleteCompanyFail';
import modalEditPhotoFormCompany from './containers/admin/forms/formCompany/modalEditPhoto';
import textFieldFormCompany from './containers/admin/forms/formCompany/textField';
import autocompleteFromCreateUser from './containers/admin/forms/formParamCreateUsers/autocomplete';
import formControlLabelFormCreateUser from './containers/admin/forms/formParamCreateUsers/formControlLabel';
import formLabelFormCreateUser from './containers/admin/forms/formParamCreateUsers/formLabel';
import textFieldFormCreateUser from './containers/admin/forms/formParamCreateUsers/textField';
import typographyformCreateUser from './containers/admin/forms/formParamCreateUsers/typography';
import autocompleteFormParamEquipModel from './containers/admin/forms/formParamEquipmentModels/autocomplete';
import handleDeleteEquipmentModels from './containers/admin/forms/formParamEquipmentModels/handleDeleteEquipmentModels';
import handleDeleteEquipmentModelsFail from './containers/admin/forms/formParamEquipmentModels/handleDeleteEquipmentModelsFail';
import handleDeleteEquipmentServiceFail from './containers/admin/forms/formParamEquipmentsServices/handleDeleteEquipmentServicesFail';
import textFieldFormEquipModel from './containers/admin/forms/formParamEquipmentModels/textField';
import tooltipFormParamEquipModel from './containers/admin/forms/formParamEquipmentModels/tooltip';
import typographyFormParamEquipModel from './containers/admin/forms/formParamEquipmentModels/typography';
import typographyFormParamEquipService from './containers/admin/forms/formParamEquipmentsServices/typography';
import handleCloseFormParamFreq from './containers/admin/forms/formParamFrequency/handleClose';
import handleDeleteFrequencyFormParamFreq from './containers/admin/forms/formParamFrequency/handleDeleteFrequency';
import handleDeleteFrequencyFailFormParamFreq from './containers/admin/forms/formParamFrequency/handleDeleteFrequencyFail';
import inputLabelFormParamEquip from './containers/admin/forms/formParamFrequency/inputLabel';
import menuItemFormParamFreq from './containers/admin/forms/formParamFrequency/menuItem';
import textFieldFormParamFreq from './containers/admin/forms/formParamFrequency/textField';
import formControlLabelFormControlAbel from './containers/admin/forms/formParamFrequency/formControlLabel';
import typographyFormParamFreq from './containers/admin/forms/formParamFrequency/typography';
import autocompleteFormParamUser from './containers/admin/forms/formParamUsers/autocomplete';
import formControlLabelFormParamUser from './containers/admin/forms/formParamUsers/formControlLabel';
import formLabelFormParamUser from './containers/admin/forms/formParamUsers/formLabel';
import handleCloseFormParamUser from './containers/admin/forms/formParamUsers/handleClose';
import handleDeleteUserFormParamUser from './containers/admin/forms/formParamUsers/handleDeleteUser';
import textFieldFormParamUser from './containers/admin/forms/formParamUsers/textField';
import typographyFormParamUser from './containers/admin/forms/formParamUsers/typography';
import autocompleteFormService from './containers/admin/forms/formServices/autocomplete';
import checkDeleteCompanyCallFormService from './containers/admin/forms/formServices/checkDeleteCompanyCall';
import divFormService from './containers/admin/forms/formServices/div';
import fileDownloadButtonFormService from './containers/admin/forms/formServices/fileDownloadButton';
import handleDeleteDocumentFormService from './containers/admin/forms/formServices/handleDeleteDocument';
import handleDeleteDocumentFileFormService from './containers/admin/forms/formServices/handleDeleteDocumentFile';
import keyboardDatePickerFormService from './containers/admin/forms/formServices/keyboardDatePicker';
import textFieldFormService from './containers/admin/forms/formServices/textField';
import tooltipFormService from './containers/admin/forms/formServices/tooltip';
import typographyFormService from './containers/admin/forms/formServices/typography';
import buttonFormservQuesList from './containers/admin/forms/formServicesQuestionList/button';
import formControlLabelFormServiceQuestList from './containers/admin/forms/formServicesQuestionList/formControlLabel';
import textFieldFormServiceQuesList from './containers/admin/forms/formServicesQuestionList/textField';
import typographyFormServiceQuesList from './containers/admin/forms/formServicesQuestionList/typography';
import autocompleteModalFilterEquip from './containers/admin/modalFilter/equipments/autocomplete';
import statusOptions from './containers/admin/modalFilter/equipments/statusOptions';
import divModalFilterEquip from './containers/admin/modalFilter/equipments/div';
import filterListModalFilterEquip from './containers/admin/modalFilter/equipments/filterList';
import autocompleteModalFilterService from './containers/admin/modalFilter/services/autocomplete';
import divModalFilterService from './containers/admin/modalFilter/services/div';
import filterListModalFilterService from './containers/admin/modalFilter/services/filterList';
import keyboardDatePickerModalFilterService from './containers/admin/modalFilter/services/keyboardDatePicker';
import autocompleteModalFilterUser from './containers/admin/modalFilter/users/autocomplete';
import divModalFilterUser from './containers/admin/modalFilter/users/div';
import filterListModalfilterUser from './containers/admin/modalFilter/users/filterList';
import autocompleteModalAction from './containers/admin/modals/modalAction/autocomplete';
import divModalAction from './containers/admin/modals/modalAction/div';
import handleDeleteDocumentModalAction from './containers/admin/modals/modalAction/handleDeleteDocument';
import handleDeleteDocumentFileModalAction from './containers/admin/modals/modalAction/handleDeleteDocumentFile';
import keyboardDatePicker from './containers/admin/modals/modalAction/keyboardDatePicker';
import textFieldModalFilter from './containers/admin/modals/modalAction/textField';
import typographyModalAction from './containers/admin/modals/modalAction/typography';
import autocompleteModalCloneCheck from './containers/admin/modals/modalCloneChecklist/autocomplete';
import divModalCloneCheck from './containers/admin/modals/modalCloneChecklist/div';
import typographyModalCloneCheckbox from './containers/admin/modals/modalCloneChecklist/typography';
import formControlModalCloneCheckSite from './containers/admin/modals/modalCloneChecklistSite/formControl';
import setSitesToErrorMessageModalCloneCheck from './containers/admin/modals/modalCloneChecklistSite/setSitesToErrorMessage';
import typographyModalCloneCheckSite from './containers/admin/modals/modalCloneChecklistSite/typography';
import autocompleteModalCloneEquipModel from './containers/admin/modals/modalCloneEquipmentModel/autocomplete';
import textFieldModalCloneEquipModel from './containers/admin/modals/modalCloneEquipmentModel/textField';
import typographyModalCloneEquipModel from './containers/admin/modals/modalCloneEquipmentModel/typography';
import autocompleteModalDocCompany from './containers/admin/modals/modalDocumentCompany/autocomplete';
import divModalDocCompany from './containers/admin/modals/modalDocumentCompany/div';
import handleDeleteDocumentModalDocCompany from './containers/admin/modals/modalDocumentCompany/handleDeleteDocument';
import handleDeleteDocumentFileModalDocCompany from './containers/admin/modals/modalDocumentCompany/handleDeleteDocumentFile';
import keyboardDatePickerModalDocCompany from './containers/admin/modals/modalDocumentCompany/keyboardDatePicker';
import textFieldModelDocCompany from './containers/admin/modals/modalDocumentCompany/textField';
import typographyModalDocCompany from './containers/admin/modals/modalDocumentCompany/typography';
import autocompleteModalDocEmployee from './containers/admin/modals/modalDocumentEmployee/autocomplete';
import divModalDocEmployee from './containers/admin/modals/modalDocumentEmployee/div';
import handleDeleteDocumentModalDocEmployee from './containers/admin/modals/modalDocumentEmployee/handleDeleteDocument';
import handleDeleteDocumentFileModalDocEmployee from './containers/admin/modals/modalDocumentEmployee/handleDeleteDocumentFile';
import keyboardDatePickerModalDocEmployee from './containers/admin/modals/modalDocumentEmployee/keyboardDatePicker';
import textFieldModalDocEmployee from './containers/admin/modals/modalDocumentEmployee/textField';
import typographyModalDocEmployee from './containers/admin/modals/modalDocumentEmployee/typography';
import groupQuestionArray from './containers/admin/modals/modalEquipmentChecklist/div';
import autocompleteModalEquipService from './containers/admin/modals/modalEquipmentServices/autocomplete';
import buttonModalEquipService from './containers/admin/modals/modalEquipmentServices/button';
import deleteChecklistButton from './containers/admin/modals/modalEquipmentServices/deleteChecklistButton';
import divModalEquipService from './containers/admin/modals/modalEquipmentServices/div';
import groupCreateButtonModalEquipService from './containers/admin/modals/modalEquipmentServices/groupCreateButton';
import handleClickDeleteChecklistModalEquipService from './containers/admin/modals/modalEquipmentServices/handleClickDeleteChecklist';
import handleDeleteGroupModalEquipService from './containers/admin/modals/modalEquipmentServices/handleDeleteGroup';
import handleDeleteQuestionModalEquipService from './containers/admin/modals/modalEquipmentServices/handleDeleteQuestion';
import handleDeleteServiceModalEquipService from './containers/admin/modals/modalEquipmentServices/handleDeleteService';
import tooltipCommentFlagIcon from './containers/admin/modals/modalEquipmentServices/tooltipCommentFlagIcon';
import typographyModelEquipService from './containers/admin/modals/modalEquipmentServices/typography';
import textFieldModalEquipServiceGroup from './containers/admin/modals/modalEquipmentServicesGroup/textField';
import typographyModalEquipServiceGroup from './containers/admin/modals/modalEquipmentServicesGroup/typography';
import autocompleteModalEquipServQuest from './containers/admin/modals/modalEquipmentServicesQuestion/autocomplete';
import modalEditPhotoModalEquipServiceQuest from './containers/admin/modals/modalEquipmentServicesQuestion/modalEditPhoto';
import switchModalEquipServQuest from './containers/admin/modals/modalEquipmentServicesQuestion/switch';
import textFieldModalEquipServQuest from './containers/admin/modals/modalEquipmentServicesQuestion/textField';
import typographyModalEquipServQuest from './containers/admin/modals/modalEquipmentServicesQuestion/typography';
import autocompleteModalPlace from './containers/admin/modals/modalPlaces/autocomplete';
import formControlLabelModalPlace from './containers/admin/modals/modalPlaces/formControlLabel';
import handleDeletePlaceModalPlaces from './containers/admin/modals/modalPlaces/handleDeletePlace';
import textFieldModalPlaces from './containers/admin/modals/modalPlaces/textField';
import typographyModalPlaces from './containers/admin/modals/modalPlaces/typography';
import reactToPrintModalQRCode from './containers/admin/modals/ModalQRCode/reactToPrint';
import autocompleteFormActions from './containers/actions/formActions/autocomplete';
import buttonFormActions from './containers/actions/formActions/button';
import divFormActions from './containers/actions/formActions/div';
import expandPainelButtonFormActions from './containers/actions/formActions/expandPainelButton';
import expandPainelItemLabelformActions from './containers/actions/formActions/expandPainelItemLabel';
import formStatusLabelFormActions from './containers/actions/formActions/formStatusLabel';
import handleCancelActionFormActions from './containers/actions/formActions/handleCancelAction';
import handleCompleteActionFormActions from './containers/actions/formActions/handleCompleteAction';
import handleDeleteFormActions from './containers/actions/formActions/handleDelete';
import handleDeleteDocumentFileFormActions from './containers/actions/formActions/handleDeleteDocumentFile';
import handleReopenActionFormActions from './containers/actions/formActions/handleReopenAction';
import keyboardDatePickerFormActions from './containers/actions/formActions/keyboardDatePicker';
import setSelectedStatusFormActions from './containers/actions/formActions/setSelectedStatus';
import textFieldFormActions from './containers/actions/formActions/textField';
import tooltipFormActions from './containers/actions/formActions/tooltip';
import typographyFormActions from './containers/actions/formActions/typography';
import autocompleteActionModalFilter from './containers/actions/modalFilter/autocomplete';
import divActionModalFilter from './containers/actions/modalFilter/div';
import filterListActionModalFilter from './containers/actions/modalFilter/filterList';
import keyboardDatePickerActionModalFilter from './containers/actions/modalFilter/keyboardDatePicker';
import statusActionModalFilter from './containers/actions/modalFilter/status';
import avatarTableActions from './containers/actions/tableActions/avatar';
import buttonTableActions from './containers/actions/tableActions/button';
import divTableActions from './containers/actions/tableActions/div';
import headRowsTableActions from './containers/actions/tableActions/headRows';
import tableTitleTableActions from './containers/actions/tableActions/tableTitle';
import typographyTablesActions from './containers/actions/tableActions/typography';
import buttonTimeActions from './containers/actions/timelineActions/button';
import inputViewTimeActions from './containers/actions/timelineActions/inputView';
import typographyTimeActions from './containers/actions/timelineActions/typography';
import buttonCompCalendar from './components/calendar/calendar/button';
import calendarStyledCompCalendar from './components/calendar/calendar/calendarStyled';
import fileDownloadButtonCompCalendar from './components/calendar/calendar/fileDownloadButton';
import typographyCalendar from './components/calendar/calendar/typography';
import divCalendarActionCard from './components/calendar/eventModal/eventModalCard/cardTypes/actionCard/div';
import autocompleteCalendarFilter from './components/calendar/modalFilter/autocomplete';
import divCalendarModalFilter from './components/calendar/modalFilter/div';
import filterListModal from './components/calendar/modalFilter/filterList';
import formControlLabelCalendar from './components/calendar/modalFilter/formControlLabel';
import createButtonCompChecklist from './components/checklist/createButton';
import listChecklistItem from './components/checklist/listItemText';
import buttonEquipStatusInput from './components/equipmentChangeStatusInput/button';
import textFieldEquipStatusInput from './components/equipmentChangeStatusInput/textField';
import activeButtonEquipStatusBtn from './components/equipmentStatusButton/activeButton';
import maintenanceButtonEquip from './components/equipmentStatusButton/maintenanceButton';
import buttonFileDownBtn from './components/fileDownloadButton/button';
import place_list_button from './components/fileDownloadButton/handleDownload/place_list_button';
import iconButtonFileDownBtn from './components/fileDownloadButton/iconButton';
import toastrFileDownBtn from './components/fileDownloadButton/toastr';
import btnNewActionPost from './components/newActionPostInput/button';
import newActionHeader from './components/newActionPostInput/containerHeader';
import inputErrorLabelNew from './components/newActionPostInput/inputErrorLabel';
import inputFilesLabelNew from './components/newActionPostInput/inputFilesLabel';
import inputViewNew from './components/newActionPostInput/inputView';
import accessStatus from './components/status/access';
import docMissingCompanyStatus from './components/status/docMissingCompany';
import docMissingEmployeeStatus from './components/status/docMissingEmployee';
import getMissingDocumentsStatus from './components/status/getMissingDocuments';
import avatarTabsEquip from './components/tabs/tabsEquipment/avatar';
import tabEquip from './components/tabs/tabsEquipment/tab';
import avatarConfirmTenant from './containers/login/confirmAddTenant/avatar';
import buttonConfirmTenant from './containers/login/confirmAddTenant/button';
import divConfirmTenant from './containers/login/confirmAddTenant/div';
import gridLogin from './containers/login/confirmAddTenant/grid';
import navLinkStyledConfirmTenant from './containers/login/confirmAddTenant/navLinkStyled';
import textFieldLogin from './containers/login/confirmAddTenant/textField';
import btnConfirmCreateUser from './containers/login/confirmCreateUser/button';
import divConfirmCreateUser from './containers/login/confirmCreateUser/div';
import navLinkConfirmCreateUser from './containers/login/confirmCreateUser/navLinkStyled';
import textFieldConfirmCreateUser from './containers/login/confirmCreateUser/textField';
import btnForgotPassword from './containers/login/forgotPassword/button';
import divForgotPassword from './containers/login/forgotPassword/div';
import textFieldForgotPassword from './containers/login/forgotPassword/textField';
import buttonForgotPassConfirm from './containers/login/forgotPasswordConfirmation/button';
import divForgotPassConfirm from './containers/login/forgotPasswordConfirmation/div';
import navLinkStyledFPC from './containers/login/forgotPasswordConfirmation/navLinkStyled';
import textFieldForgotPasswordConfirm from './containers/login/forgotPasswordConfirmation/textField';
import divLogin from './containers/login/login/div';
import navLinkStyledLogin from './containers/login/login/navLinkStyled';
import textFieldLogin1 from './containers/login/login/textField';
import typographyPendente from './containers/login/pendente/typography';
import btnSignUp from './containers/login/signUp/button';
import navLinkStyledSignUp from './containers/login/signUp/navLinkStyled';
import textFieldSignUp from './containers/login/signUp/textField';
import divTenantSelector from './containers/login/tenantSelector/div';
import handleCloseMyCompany from './containers/myCompany/handleClose';
import handleDeleteEmployeeMyComp from './containers/myCompany/handleDeleteEmployee';
import ModalEditPhotoMyComp from './containers/myCompany/modalEditPhoto';
import typographyMyComp from './containers/myCompany/typography';
import modalPhotoEditorUserMyAccount from './containers/user/myAccount/modalPhotoEditor';
import textFieldUserMyAccount from './containers/user/myAccount/textField';
import typoUserMyAccount from './containers/user/myAccount/typography';
import tooltipActionExpPanel from './ui/actionExpansionPanel/tooltip';
import typographyActionExpansion from './ui/actionExpansionPanel/typography';
import divCardsTimeLine from './ui/cards/actionCardTimeline/div';
import divActionLogs from './ui/cards/actionLogsCardTimeline/div';
import divCardEquipment from './ui/cards/cardEquipment/div';
import divCardTimeline from './ui/cards/cardTimeline/div';
import btnConfirmDialog from './ui/confirm/confirmDialog/button';
import divFileList from './ui/fileList/div';
import mandDoclistItemText from './ui/mandatoryDocuments/listItemText';
import tooltipMatTableOver from './ui/materialTableOverrides/tableActionButtons-legacy/tooltip';
import btnTableTileMatOverrides from './ui/materialTableOverrides/tableTitle/button';
import divTableTitleMat from './ui/materialTableOverrides/tableTitle/div';
import divPhotoUp from './ui/photoBarUploading/div';
import uploadMessagePhotoUp from './ui/photoUpload/uploadMessage';
import divSignUpTenantsCards from './ui/signUpTenantsCards/div';
import timelineContent from './ui/timeline/timelineContent';
import btnTreeNode from './ui/tree/treeNode/button';
import fileDownloadButtonTreeNode from './ui/tree/treeNode/fileDownloadButton';
import leafNametreeNode from './ui/tree/treeNode/leafName';
import uploadMessage from './ui/upload/uploadMessage';
//import deleteCheckMessage from './utils/deleteCheckMessage';
import doneActionsOutput from './utils/formatCalendarEvents/doneActionsOutput';
import doneServicesOutput from './utils/formatCalendarEvents/doneServicesOutput';
import scheduledServicesOutput from './utils/formatCalendarEvents/scheduledServicesOutput';
import locationError from './utils/getLocation/locationError';
import monthToText from './utils/monthToText';
import statusLabel from './utils/statusLabel';
import statusManipulation from './utils/statusManipulation';
import tableConfig from './utils/tableConfig';
import weekDayToText from './utils/weekDayToText';
import divEquipServCard from './components/calendar/eventModal/eventModalCard/cardTypes/serviceAction/div';
import titleHeaderEvent from './components/calendar/eventModal/eventModalHeader';
import divModalEquipCheckList from './containers/admin/modals/modalEquipmentChecklist/div';
import formatLabel from './utils/equipmentLogCardLabel/formatLabel';
import formatTitle from './utils/equipmentLogCardLabel/formatTitle';
import btnFormEquip from './containers/admin/forms/formEquipments/formEquipmentsServices/button';

import addMessageTimelineActionStr from './store/actions/actions/addMessageTimelineAction';
import deleteActionsStore from './store/actions/actions/deleteActions';
import postActionsStore from './store/actions/actions/postActions';
import updateActionsStore from './store/actions/actions/updateActions';
import usersReducers from './store/reducers/users'
import deleteAreasStr from './store/actions/areas/deleteAreas';
import postAreasStr from './store/actions/areas/postAreas';
import updateAreasStr from './store/actions/areas/updateAreas';
import changeAutomaticEmailsStr from './store/actions/auth/changeAutomaticEmails';
import changeNameStr from './store/actions/auth/changeName';
import changePasswordStr from './store/actions/auth/changePassword';
import changeProfilePictureStr from './store/actions/auth/changeProfilePicture';
import deleteAddDocumentCompanies from './store/actions/companies/deleteAddDocumentCompanies';
import deleteCompaniesStr from './store/actions/companies/deleteCompanies';
import postAddDocumentCompanies from './store/actions/companies/postAddDocumentCompanies';
import postCompaniesStr from './store/actions/companies/postCompanies';
import updateAddDocumentCompanies from './store/actions/companies/updateAddDocumentCompanies';
import updateCompaniesStr from './store/actions/companies/updateCompanies';
import deleteChecklistBySiteStr from './store/actions/equipmentModels/deleteChecklistBySite';
import deleteEquipmentModelsStr from './store/actions/equipmentModels/deleteEquipmentModels';
import postCloneChecklist from './store/actions/equipmentModels/postCloneChecklist';
import postCloneChecklistBySite from './store/actions/equipmentModels/postCloneChecklistBySite';
import postCloneEquipmentModels from './store/actions/equipmentModels/postCloneEquipmentModels';
import postEquipmentModelsStr from './store/actions/equipmentModels/postCloneEquipmentModels';
import updateEquipmentModels from './store/actions/equipmentModels/updateEquipmentModels';
import deleteEquipments from './store/actions/equipments/deleteEquipments';
import getEquipmentsQRCodes from './store/actions/equipments/getEquipmentsQRCodes';
import inactivateEquipments from './store/actions/equipments/inactivateEquipments';
import postEquipmentsStr from './store/actions/equipments/postEquipments';
import updateEquipmentsStr from './store/actions/equipments/updateEquipments';
import deleteEquipmentServices from './store/actions/equipmentServices/deleteEquipmentServices';
import hardDeleteEquipmentServices from './store/actions/equipmentServices/hardDeleteEquipmentServices';
import postEquipmentServices from './store/actions/equipmentServices/postEquipmentServices';
import updateEquipmentServices from './store/actions/equipmentServices/updateEquipmentServices';
import deleteFrequency from './store/actions/frequency/deleteFrequency';
import postFrequencyStr from './store/actions/frequency/postFrequency';
import updateFrequencyStr from './store/actions/frequency/updateFrequency';
import postGroupsStr from './store/actions/groups/postGroups';
import updateGroupsStr from './store/actions/groups/updateGroups';
import groupsStr from './store/actions/groups/index';
import copyPasteRequestStr from './store/actions/places/copyPasteRequest';
import deletePlacesStr from './store/actions/places/deletePlaces';
import postPlacesStr from './store/actions/places/postPlaces';
import setCopyPlace from './store/actions/places/setCopyPlace';
import updatePlacesStr from './store/actions/places/updatePlaces';
import deleteQuestionsStr from './store/actions/questions/deleteQuestions';
import postQuestions from './store/actions/questions/postQuestions';
import updateQuestions from './store/actions/questions/updateQuestions';
import deleteQuicksight from './store/actions/quicksight/deleteQuicksight';
import postQuicksight from './store/actions/quicksight/postQuicksight';
import updateQuicksight from './store/actions/quicksight/updateQuicksight';
import deleteRoles from './store/actions/roles/deleteRoles';
import postRoles from './store/actions/roles/postRoles';
import updateRoles from './store/actions/roles/updateRoles';
import deleteAddDocumentServices from './store/actions/services/deleteAddDocumentServices';
import deleteServices from './store/actions/services/deleteServices';
import postAddDocumentServices from './store/actions/services/postAddDocumentServices';
import postServices from './store/actions/services/postServices';
import updateAddDocumentServices from './store/actions/services/updateAddDocumentServices';
import updateServices from './store/actions/services/updateServices';
import deleteServiceTypes from './store/actions/serviceTypes/deleteServiceTypes';
import postServiceTypes from './store/actions/serviceTypes/postServiceTypes';
import updateServiceTypes from './store/actions/serviceTypes/updateServiceTypes';
import deleteSites from './store/actions/sites/deleteSites';
import postSites from './store/actions/sites/postSites';
import updateSites from './store/actions/sites/updateSites';
import deleteStatusVerificationItems from './store/actions/statusVerificationItems/deleteStatusVerificationItems';
import postStatusVerificationItems from './store/actions/statusVerificationItems/postStatusVerificationItems';
import updateStatusVerificationItems from './store/actions/statusVerificationItems/updateStatusVerificationItems';
import deleteFeatureFlags from './store/actions/tenants/deleteFeatureFlags';
import deleteTenants from './store/actions/tenants/deleteTenants';
import postFeatureFlags from './store/actions/tenants/postFeatureFlags';
import postTenants from './store/actions/tenants/postTenants';
import updateFeatureFlags from './store/actions/tenants/updateFeatureFlags';
import updateTenants from './store/actions/tenants/updateTenants';
import updateTenantsSuperadmin from './store/actions/tenants/updateTenantsSuperadmin';
import forgotPassword from './store/actions/users/forgotPassword';
import forgotPasswordActivate from './store/actions/users/forgotPasswordActivate';
import inviteAddTenant from './store/actions/users/inviteAddTenant';
import inviteCreateUser from './store/actions/users/inviteCreateUser';
import inviteSignup from './store/actions/users/inviteSignup';
import inviteSignupBySuperAdmin from './store/actions/users/inviteSignupBySuperAdmin';
import updateUserAccess from './store/actions/users/updateUserAccess';
import updateUserAccessBySuperadmin from './store/actions/users/updateUserAccessBySuperadmin';
import headRows from './components/arquivos/headRows';
import files from './components/arquivos/files';
import filesTypography from './components/arquivos/typography';
import supportBtn from './components/arquivos/arquivosSuporte/btn';
import headRowsSupport from './components/arquivos/arquivosSuporte/headRows';
import supportTypo from './components/arquivos/arquivosSuporte/typography';

import handleDeleteDocumentModalSupport from './components/arquivos/modalSupportFiles/handleDeleteDocument';
import formControlLabelModalSupportFiles from './components/arquivos/modalSupportFiles/formControlLabel';
import formLabelModalSupportFiles from './components/arquivos/modalSupportFiles/formLabel';
import modalSupportTextField from './components/arquivos/modalSupportFiles/textField';
import modalSupportTypo from './components/arquivos/modalSupportFiles/typography';
import uploadEmptyFileErrorModalSupport from './components/arquivos/modalSupportFiles/uploadEmptyFileError';
import uploadSubmitErrorModalSupport from './components/arquivos/modalSupportFiles/uploadSubmitError';
import visibility from './components/arquivos/arquivosSuporte/visibility';

import updateBackupsStr from './store/actions/backupsApp';
import modalBackups from './containers/admin/modals/modalBackup';
import btnFilterManagementBackups from './containers/admin/tables/tableManagementBackups/button';
import headRowsManagementBackups from './containers/admin/tables/tableManagementBackups/headRows';
import tableTitleManagementBackups from './containers/admin/tables/tableManagementBackups/tableTitle';

import attachmentFilesEquipmentModelsBtn from './components/arquivos/attachmentFilesEquipmentModels/btn';
import attachmentFilesEquipmentModelsTypo from './components/arquivos/attachmentFilesEquipmentModels/typography';
import attachmentFilesEquipmentModelsModal from './components/arquivos/attachmentFilesEquipmentModels/modal';
import handleAttachFile from './components/arquivos/attachmentFilesEquipmentModels/handleAttachFile';
import attachmentFilesEquipmentsTypo from './components/arquivos/attachmentFilesEquipments/typography';

import formRestoreEquipment from './containers/admin/forms/formRestoreEquipment';
import restoreEquipments from './store/actions/equipments/restoreEquipments';
import adminOptions from './containers/admin/modalFilter/equipments/adminOptions';
import tableCellEquip from './containers/admin/tables/paramEquipmentModels/tableCellEquip';
import btnCompleteAction from './components/completeActionModel/button';
import typographyCompleteActionModal from './components/completeActionModel/typography';
import tabsChecklistQuestions from './containers/admin/modals/modalEquipmentServicesQuestion/tabs';
import maintenancesTab from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/tabs';
import maintenanceCardLabel from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/cardTimeline';
import formMaintenance from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/formMaintenance';
import maintenanceMessages from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/toastrMessages';
import maintenanceTimelineContent from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/maintenanceTimelineContent';
import maintenancesOutput from './utils/formatCalendarEvents/maintenancesOutput';
import maintenancesStatusLabel from './utils/maintenancesStatusLabel';
import buttonFormMaintenance from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/buttonFormMaintenance';
import handleMaintenanceStatusModal from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/handleMaintenanceStatusModal';
import handleDeleteMaintenanceModal from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/handleDeleteMaintenanceModal';
import headRowsTableMaintenances from './containers/maintenances/tableMaintenances/headRows';
import tableTitleTableMaintenances from './containers/maintenances/tableMaintenances/tableTitle';
import autocompleteMaintenanceModalFilter from './containers/maintenances/modalFilter/autocomplete';
import handleDatePickerErrorMessage from './containers/admin/forms/formEquipments/formEquipmentsMaintenances/handleDatePickerErrorMessage';
import calendarChipsToggles from './components/calendar/calendar/calendarChipsToggles';
import reportsPage from './containers/admin/reports';
import condensedReport from './containers/admin/reports/condensedReport';
import handleCloseDialogModalEquipService from './containers/admin/modals/modalEquipmentServices/handleCloseDialog';
import maintenanceEquipments from '../pt/store/actions/equipments/maintenanceEquipments';
import qrcodeInstructions from './containers/qrcode/instructions';
import blockedTenantDialog from './blockedTenant';
import tableTitleExpiredServices from './containers/admin/tables/tableExpiredServices/tableTitle';
import tableCellExpiredServices from './containers/admin/tables/tableExpiredServices/tableCell';
import btnClearFilterExpiredServices from './containers/admin/tables/tableExpiredServices/clearFilterButton';
import btnExpiredServices from './containers/admin/tables/tableExpiredServices/button';
import headRowsExpiredServices from './containers/admin/tables/tableExpiredServices/headRows';
import autocompleteModalFilterExpiredServices from './containers/admin/modalFilter/expiredServices/autocomplete';
import divModalFilterExpiredServices from './containers/admin/modalFilter/expiredServices/div';
import filterListModalFilterExpiredServices from './containers/admin/modalFilter/expiredServices/filterList';
import keyboardDatePickerModalFilterExpiredServices from './containers/admin/modalFilter/expiredServices/keyboardDatePicker';
import chipsExpiredServices from './containers/admin/tables/tableExpiredServices/chips';
import modalMassService from './containers/admin/modals/modalMassService';
import checklistServiceButton from './components/checklist/checklistServiceButton';
import serviceOldActionsPanel from './components/serviceOldActionsPanel';
import createService from './containers/services/createService';
import editService from './containers/services/editService';

import equipmentBadgeStatus from './utils/statusManipulation/equipmentBagdeStatus';
import selectServiceType from './containers/services/createService/selectServiceType'
import formParamNotificationWebhook from './containers/admin/forms/formParamNotificationWebhook';
import dropContainer from './containers/scheduledServices/dropContainer';
import scheduledServicesStore from './store/actions/scheduledServices';
import scheduledServicesUsersFilterModal from './containers/scheduledServices/usersFiltersModal';
import scheduledServicesServicesForSchedulingFilterModal from './containers/scheduledServices/servicesForSchedulingFiltersModal';
import scheduledServicesUsersFilters from './containers/scheduledServices/usersFilters';
import scheduledServicesPlannerHeader from './containers/scheduledServices/plannerHeader';
import scheduledServicesEventCardList from './containers/scheduledServices/eventCardList';
import scheduledServicesDraggableCard from './containers/scheduledServices/draggableCard';
import scheduledServicesByUserAndDayModal from './containers/scheduledServices/scheduledServicesByUserAndDayModal';
import scheduledServicesCalendarHeader from './containers/scheduledServices/scheduledServicesCalendarHeader';
import scheduledServicesCalendarFilterModal from './containers/scheduledServices/scheduledServicesCalendarFiltersModal';
import scheduledServicesUsersList from './containers/scheduledServices/usersList';
import scheduledServicesCalendarCalendar from './containers/scheduledServices/scheduledServicesCalendarCalendar';
import reducerScheduledServices from './store/reducers/scheduledServices';
import calendarServiceCard from './components/calendar/serviceCard';
import equipmentInfo from './components/equipmentInfo';
import scheduleServiceModal from './components/scheduleServiceModal';
import exportModalCalendar from './components/exportModalCalendar';
import warningModalEquipService from './containers/admin/modals/modalEquipmentServices/warningModal';
import storeEquipmentService from './store/actions/equipmentServices';
import equipmentsRegistrationLimitWarning from './components/EquipmentsRegistrationLimitWarning';
import tableDataExports from './containers/admin/tables/tableDataExports';
import notionCard from './components/arquivos/notionCard';
import modalRedirect from './containers/login/modalRedirect';
import toastr from './containers/login/toastr';
import tableServiceDrafts from './containers/admin/tables/tableServiceDrafts';
import serviceDraftsFilterModal from './containers/admin/modalFilter/serviceDraftsFilterModal';
import serviceCreationBlockedModal from './components/serviceCreationBlockedModal';

const staticText = {
  pt: {
    translations: {
      equipmentsRegistrationLimitWarning,
      visibility,
      handleDeleteDocumentModalSupport,
      formControlLabelModalSupportFiles,
      formLabelModalSupportFiles,
      modalSupportTextField,
      modalSupportTypo,
      uploadEmptyFileErrorModalSupport,
      uploadSubmitErrorModalSupport,
      filesTypography,
      supportBtn,
      headRowsSupport,
      supportTypo,
      files,
      updateUserAccessBySuperadmin,
      updateUserAccess,
      inviteSignupBySuperAdmin,
      inviteSignup,
      inviteCreateUser,
      inviteAddTenant,
      forgotPasswordActivate,
      forgotPassword,
      updateTenantsSuperadmin,
      updateTenants,
      updateFeatureFlags,
      postTenants,
      postFeatureFlags,
      deleteTenants,
      deleteFeatureFlags,
      updateStatusVerificationItems,
      postStatusVerificationItems,
      deleteStatusVerificationItems,
      updateSites,
      postSites,
      deleteSites,
      updateServiceTypes,
      postServiceTypes,
      deleteServiceTypes,
      updateServices,
      updateAddDocumentServices,
      postServices,
      postAddDocumentServices,
      deleteServices,
      deleteAddDocumentServices,
      updateRoles,
      postRoles,
      deleteRoles,
      updateQuicksight,
      postQuicksight,
      deleteQuicksight,
      updateQuestions,
      postQuestions,
      deleteQuestionsStr,
      updatePlacesStr,
      setCopyPlace,
      postPlacesStr,
      deletePlacesStr,
      copyPasteRequestStr,
      groupsStr,
      updateGroupsStr,
      postGroupsStr,
      updateFrequencyStr,
      postFrequencyStr,
      deleteFrequency,
      updateEquipmentServices,
      postEquipmentServices,
      hardDeleteEquipmentServices,
      deleteEquipmentServices,
      updateEquipmentsStr,
      postEquipmentsStr,
      inactivateEquipments,
      getEquipmentsQRCodes,
      deleteEquipments,
      updateEquipmentModels,
      postEquipmentModelsStr,
      postCloneEquipmentModels,
      postCloneChecklistBySite,
      postCloneChecklist,
      deleteEquipmentModelsStr,
      deleteChecklistBySiteStr,
      updateCompaniesStr,
      updateAddDocumentCompanies,
      postCompaniesStr,
      postAddDocumentCompanies,
      deleteCompaniesStr,
      deleteAddDocumentCompanies,
      changeProfilePictureStr,
      changePasswordStr,
      changeNameStr,
      changeAutomaticEmailsStr,
      updateAreasStr,
      postAreasStr,
      deleteAreasStr,
      updateActionsStore,
      postActionsStore,
      deleteActionsStore,
      addMessageTimelineActionStr,
      usersReducers,
      headRows,
      btnFormEquip,
      formatLabel,
      formatTitle,
      divModalEquipCheckList,
      titleHeaderEvent,
      divEquipServCard,
      tooltipActionExpPanel,
      typographyActionExpansion,
      divCardsTimeLine,
      divActionLogs,
      divCardEquipment,
      divCardTimeline,
      btnConfirmDialog,
      divFileList,
      mandDoclistItemText,
      tooltipMatTableOver,
      btnTableTileMatOverrides,
      divTableTitleMat,
      divPhotoUp,
      uploadMessagePhotoUp,
      divSignUpTenantsCards,
      timelineContent,
      btnTreeNode,
      fileDownloadButtonTreeNode,
      leafNametreeNode,
      uploadMessage,
      //deleteCheckMessage,
      doneActionsOutput,
      doneServicesOutput,
      scheduledServicesOutput,
      locationError,
      monthToText,
      statusLabel,
      statusManipulation,
      tableConfig,
      weekDayToText,

      typoUserMyAccount,
      textFieldUserMyAccount,
      modalPhotoEditorUserMyAccount,
      typographyMyComp,
      ModalEditPhotoMyComp,
      handleDeleteEmployeeMyComp,
      handleCloseMyCompany,
      divTenantSelector,
      textFieldSignUp,
      navLinkStyledSignUp,
      btnSignUp,
      typographyPendente,
      textFieldLogin1,
      navLinkStyledLogin,
      divLogin,
      textFieldForgotPasswordConfirm,
      navLinkStyledFPC,
      divForgotPassConfirm,
      buttonForgotPassConfirm,
      textFieldForgotPassword,
      divForgotPassword,
      btnForgotPassword,
      textFieldConfirmCreateUser,
      navLinkConfirmCreateUser,
      divConfirmCreateUser,
      btnConfirmCreateUser,
      textFieldLogin,
      navLinkStyledConfirmTenant,
      gridLogin,
      divConfirmTenant,
      avatarConfirmTenant,
      buttonConfirmTenant,
      buttonCompCalendar,
      calendarStyledCompCalendar,
      fileDownloadButtonCompCalendar,
      typographyCalendar,
      divCalendarActionCard,
      autocompleteCalendarFilter,
      divCalendarModalFilter,
      filterListModal,
      formControlLabelCalendar,
      createButtonCompChecklist,
      listChecklistItem,
      tabEquip,
      avatarTabsEquip,
      getMissingDocumentsStatus,
      docMissingEmployeeStatus,
      docMissingCompanyStatus,
      accessStatus,
      inputViewNew,
      inputFilesLabelNew,
      inputErrorLabelNew,
      newActionHeader,
      btnNewActionPost,
      toastrFileDownBtn,
      iconButtonFileDownBtn,
      place_list_button,
      buttonFileDownBtn,
      maintenanceButtonEquip,
      activeButtonEquipStatusBtn,
      textFieldEquipStatusInput,
      buttonEquipStatusInput,
      divFormActions,
      expandPainelButtonFormActions,
      expandPainelItemLabelformActions,
      formStatusLabelFormActions,
      handleCancelActionFormActions,
      handleCompleteActionFormActions,
      handleDeleteFormActions,
      handleDeleteDocumentFileFormActions,
      handleReopenActionFormActions,
      keyboardDatePickerFormActions,
      setSelectedStatusFormActions,
      textFieldFormActions,
      tooltipFormActions,
      typographyFormActions,
      autocompleteActionModalFilter,
      divActionModalFilter,
      filterListActionModalFilter,
      keyboardDatePickerActionModalFilter,
      statusActionModalFilter,
      avatarTableActions,
      buttonTableActions,
      divTableActions,
      autocompleteFormActions,
      buttonFormActions,
      typographyTimeActions,
      inputViewTimeActions,
      buttonTimeActions,
      typographyTablesActions,
      tableTitleTableActions,
      headRowsTableActions,
      reactToPrintModalQRCode,
      typographyModalPlaces,
      textFieldModalPlaces,
      handleDeletePlaceModalPlaces,
      formControlLabelModalPlace,
      autocompleteModalPlace,
      typographyModalEquipServQuest,
      textFieldModalEquipServQuest,
      switchModalEquipServQuest,
      modalEditPhotoModalEquipServiceQuest,
      autocompleteModalEquipServQuest,
      typographyModalEquipServiceGroup,
      textFieldModalEquipServiceGroup,
      typographyModelEquipService,
      handleDeleteServiceModalEquipService,
      tooltipCommentFlagIcon,
      handleDeleteQuestionModalEquipService,
      handleDeleteGroupModalEquipService,
      handleClickDeleteChecklistModalEquipService,
      groupCreateButtonModalEquipService,
      divModalEquipService,
      deleteChecklistButton,
      buttonModalEquipService,
      autocompleteModalEquipService,
      groupQuestionArray,
      typographyModalDocEmployee,
      textFieldModalDocEmployee,
      keyboardDatePickerModalDocEmployee,
      handleDeleteDocumentFileModalDocEmployee,
      handleDeleteDocumentModalDocEmployee,
      divModalDocEmployee,
      autocompleteModalDocEmployee,
      typographyModalDocCompany,
      textFieldModelDocCompany,
      keyboardDatePickerModalDocCompany,
      handleDeleteDocumentFileModalDocCompany,
      handleDeleteDocumentModalDocCompany,
      divModalDocCompany,
      autocompleteModalDocCompany,
      typographyModalCloneEquipModel,
      textFieldModalCloneEquipModel,
      autocompleteModalCloneEquipModel,
      typographyModalCloneCheckSite,
      setSitesToErrorMessageModalCloneCheck,
      formControlModalCloneCheckSite,
      typographyModalCloneCheckbox,
      divModalCloneCheck,
      autocompleteModalCloneCheck,
      typographyModalAction,
      textFieldModalFilter,
      keyboardDatePicker,
      handleDeleteDocumentFileModalAction,
      handleDeleteDocumentModalAction,
      divModalAction,
      autocompleteModalAction,
      filterListModalfilterUser,
      divModalFilterUser,
      autocompleteModalFilterUser,
      keyboardDatePickerModalFilterService,
      filterListModalFilterService,
      divModalFilterService,
      autocompleteModalFilterService,
      filterListModalFilterEquip,
      divModalFilterEquip,
      autocompleteModalFilterEquip,
      statusOptions,
      avatarFormCompany,
      handleCloseFormCompany,
      handleDeleteCompanyFormCompany,
      handleDeleteCompanyFailformCampany,
      modalEditPhotoFormCompany,
      textFieldFormCompany,
      autocompleteFromCreateUser,
      formControlLabelFormCreateUser,
      formLabelFormCreateUser,
      textFieldFormCreateUser,
      typographyformCreateUser,
      autocompleteFormParamEquipModel,
      handleDeleteEquipmentModels,
      handleDeleteEquipmentModelsFail,
      handleDeleteEquipmentServiceFail,
      textFieldFormEquipModel,
      tooltipFormParamEquipModel,
      typographyFormParamEquipModel,
      typographyFormParamEquipService,
      handleCloseFormParamFreq,
      formControlLabelFormControlAbel,
      handleDeleteFrequencyFormParamFreq,
      handleDeleteFrequencyFailFormParamFreq,
      inputLabelFormParamEquip,
      menuItemFormParamFreq,
      textFieldFormParamFreq,
      typographyFormParamFreq,
      autocompleteFormParamUser,
      formControlLabelFormParamUser,
      formLabelFormParamUser,
      handleCloseFormParamUser,
      handleDeleteUserFormParamUser,
      textFieldFormParamUser,
      typographyFormParamUser,
      autocompleteFormService,
      checkDeleteCompanyCallFormService,
      divFormService,
      fileDownloadButtonFormService,
      handleDeleteDocumentFormService,
      handleDeleteDocumentFileFormService,
      keyboardDatePickerFormService,
      textFieldFormService,
      tooltipFormService,
      typographyFormService,
      buttonFormservQuesList,
      formControlLabelFormServiceQuestList,
      textFieldFormServiceQuesList,
      typographyFormServiceQuesList,
      autocompleteFormEquip,
      avatarFormEquip,
      divFormTitle,
      equipmentChangeStatusInput,
      handleDeleteEquipment,
      modalEditPhotoFormEquip,
      photoBarUploadingFormEquip,
      textFieldFormEquip,
      updateEquipments,
      formEquipmentActions,
      formEquipmentsLogs,
      divFromEquipService,
      typographyformEquipServ,
      divFormEquipServType,
      keyboardDatePickerFormEquipServType,
      items,
      others,
      wellcome,
      myAccount,
      roleNames,
      reasonNames,
      objectItems,
      render,
      fetchAreas,
      headRowsAreas,
      tableCellAreas,
      tableTitleAreas,
      headRowsEquip,
      tableTitleEquip,
      fetchEquip,
      btn,
      chip,
      Equipmament,
      equipmentsByPlace,
      FileDownloadButton,
      TableTitle,
      headRowsFreq,
      setLabelFrequency,
      tableTitleFrequency,
      headRowsGroup,
      tableCellGroup,
      tableTitleGroup,
      tableTitleMap,
      tableTitlePlaces,
      headRowsService,
      tableCellService,
      tableTitleService,
      headRowsVerification,
      editSwitch,
      tableCellVerification,
      TableTitleVerification,
      headRowsTypeService,
      tableCellServiceType,
      tableTitleServiceType,
      buttonFilterUser,
      clearFilterButton,
      getHoursFromNow,
      headRowsUsers,
      headRowsInvitationsUsers,
      linkInvitationUserCopiedToClipboard,
      tableCellUser,
      tableTitleUser,
      tabsUser,
      headRowsCompany,
      tableCellCompany,
      tableTitleCompany,
      btnFilterManagementEquip,
      clearFilterButtonManagementEquip,
      changeStatusInputManagementEquip,
      headRowsManagementEquip,
      tableTitleManagementEquip,
      btnManagementService,
      btnClearFilterManagementService,
      headRowsManagementService,
      tableCellManagementService,
      tableTitleManagementService,

      updateBackupsStr,
      modalBackups,
      btnFilterManagementBackups,
      headRowsManagementBackups,
      tableTitleManagementBackups,

      attachmentFilesEquipmentModelsBtn,
      attachmentFilesEquipmentModelsTypo,
      attachmentFilesEquipmentModelsModal,
      handleAttachFile,
      attachmentFilesEquipmentsTypo,

      formRestoreEquipment,
      restoreEquipments,
      adminOptions,
      tableCellEquip,
      btnCompleteAction,
      typographyCompleteActionModal,
      tabsChecklistQuestions,

      maintenancesTab,
      maintenanceCardLabel,
      formMaintenance,
      maintenanceMessages,
      maintenanceTimelineContent,
      maintenancesOutput,
      maintenancesStatusLabel,
      buttonFormMaintenance,
      handleMaintenanceStatusModal,
      handleDeleteMaintenanceModal,
      headRowsTableMaintenances,
      tableTitleTableMaintenances,
      autocompleteMaintenanceModalFilter,
      handleDatePickerErrorMessage,
      calendarChipsToggles,
      reportsPage,
      condensedReport,
      handleCloseDialogModalEquipService,
      maintenanceEquipments,
      qrcodeInstructions,
      blockedTenantDialog,
      tableTitleExpiredServices,
      tableCellExpiredServices,
      btnClearFilterExpiredServices,
      btnExpiredServices,
      headRowsExpiredServices,
      autocompleteModalFilterExpiredServices,
      divModalFilterExpiredServices,
      filterListModalFilterExpiredServices,
      keyboardDatePickerModalFilterExpiredServices,
      chipsExpiredServices,
      modalMassService,
      checklistServiceButton,
      serviceOldActionsPanel,
      createService,
      editService,
      equipmentBadgeStatus,
      selectServiceType,
      formParamNotificationWebhook,
      dropContainer,
      scheduledServicesStore,
      scheduledServicesUsersFilterModal,
      scheduledServicesServicesForSchedulingFilterModal,
      scheduledServicesPlannerHeader,
      scheduledServicesUsersFilters,
      scheduledServicesEventCardList,
      scheduledServicesDraggableCard,
      scheduledServicesByUserAndDayModal,
      scheduledServicesCalendarHeader,
      scheduledServicesCalendarFilterModal,
      scheduledServicesUsersList,
      scheduledServicesCalendarCalendar,
      reducerScheduledServices,
      calendarServiceCard,
      equipmentInfo,
      scheduleServiceModal,
      exportModalCalendar,
      warningModalEquipService,
      storeEquipmentService,
      tableDataExports,
      notionCard,
      modalRedirect,
      toastr,
      tableServiceDrafts,
      serviceDraftsFilterModal,
      serviceCreationBlockedModal,
    }
  }
};

export { staticText }
